export const environment = {
  production: true,
  api: 'https://api.korzyscimurowane.pl/platform',
  ga: 'GTM-PFS67M2',
  gat_gtag: 'UA-35501315-17'
};
